import { Warehouse } from '../types'
import createAPIClient from '../services/apiClient'

const api = createAPIClient('/v2')

export async function getWarehouses(): Promise<Warehouse[]> {
  const response = await api.get('/warehouses')

  return response.data
}

export default {
  getWarehouses
}
